export const loading = state => {
  return state.loading
}

export const isLoggedIn = state => {
  return state.isLoggedIn
}

export const isInAdminRole = state => {
  return state.isInAdminRole
}

export const isInManagerRole = state => {
  return state.isInManagerRole
}

export const userId = state => {
  return state.userId
}

export const userRole = state => {
  return state.userRole
}

export const userName = state => {
  return state.userName
}

export const enums = state => {
  return state.enums
}

export const accesses = state => {
  return state.accesses
}